import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Heart, HeartFill } from 'react-bootstrap-icons';
import { toast } from 'react-hot-toast';
import { useAuth } from "../context/authContext";
const API = process.env.REACT_APP_API_URL;
const SearchPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const query = searchParams.get('q')?.trim() || '';

    const { wishlist, handleAddToWishlist, handleRemoveFromWishlist, products, fetchProducts } = useAuth();

    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (products.length === 0) {
            fetchProducts();
        }

        if (query && products.length > 0) {
            const results = products.filter(product =>
                product.name?.toLowerCase().includes(query.toLowerCase()) ||
                product.category?.toLowerCase().includes(query.toLowerCase()) ||
                product.smalldescription?.toLowerCase().includes(query.toLowerCase()) ||
                product.description?.toLowerCase().includes(query.toLowerCase())
            );
            setFilteredProducts(results);
            setLoading(false);
        } else if (query === '') {
            setFilteredProducts([]);
            setLoading(false);
        }
    }, [query, products, fetchProducts]);

    const handleCardClick = (id) => navigate(`/product/${id}`);
    

    const handleWishlistToggle = async (e, product_id) => {
        e.stopPropagation();
        const token = localStorage.getItem('token');
        if (!token) {
            toast.info('Please login to add to wishlist');
            return;
        }

const isInWishlist = wishlist.some(item => item.product_id === product_id);
        try {
            if (isInWishlist) {
                await handleRemoveFromWishlist(product_id);
                toast.success('Removed from wishlist');
            } else {
                await handleAddToWishlist(product_id);
                toast.success('Added to wishlist!');
            }
        } catch (err) {
            toast.error('Failed to update wishlist');
        }
    };

    // Loading State
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-2xl font-bold text-red-600">Searching for "{query}"...</div>
            </div>
        );
    }

    // No Results
    if (filteredProducts.length === 0) {
        return (
            <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center py-20 px-4">
                <i className="fas fa-search text-8xl text-gray-300 mb-8"></i>
                <h2 className="text-4xl font-bold text-gray-700 mb-4 text-center">
                    No products found for <span className="text-red-600">"{query}"</span>
                </h2>
                <p className="text-xl text-gray-500 mb-8">Try different keywords or check spelling</p>
                <button
                    onClick={() => navigate('/')}
                    className="px-10 py-4 bg-gradient-to-r from-red-600 to-red-700 text-white font-bold rounded-xl hover:from-red-700 hover:to-red-800 transition shadow-lg text-lg"
                >
                    Back to Home
                </button>
            </div>
        );
    }

    // Results Found — EXACT SAME DESIGN AS CATEGORY PAGE
    return (
        <div className="min-h-screen bg-gray-50 pt-10 pb-20">
            {/* Search Header */}
            <div className="text-center mb-12">
                <h1 className="text-4xl font-black text-gray-800">
                    Search Results
                </h1>
                <p className="text-xl text-gray-600 mt-4">
                    Found <span className="text-red-600 font-bold">{filteredProducts.length}</span> product{filteredProducts.length > 1 ? 's' : ''} for
                    <span className="text-red-600 font-bold"> "{query}"</span>
                </p>
            </div>

            {/* Products Grid - IDENTICAL TO Categoryproducts */}
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-6">
                    {filteredProducts.map(product => {
const isInWishlist = wishlist.some(item => item.product_id === product.id);
                        return (
                            <div
                                key={product.id}
                                onClick={() => handleCardClick(product.id)}
                                className="group cursor-pointer"
                            >
                                <div className="bg-white rounded-2xl h-[300px] w-[150px] shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden">
                                    {/* Image Container */}
                                    <div className="relative bg-gray-100 aspect-[4/5] sm:aspect-square overflow-hidden">
                                        <img
                                            src={`${API}${product.image_url}`}
                                            alt={product.name}
                                            className="absolute inset-0 w-full h-full object-contain p-6 group-hover:scale-110 transition-transform duration-500"
                                        />

                                        {/* Wishlist Heart */}
                                        <div
                                            onClick={(e) => handleWishlistToggle(e,product.id)}
                                            className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-lg hover:scale-110 transition"
                                        >
                                            {isInWishlist ? (
                                                <HeartFill className="text-red-500 text-xl" />
                                            ) : (
                                                <Heart className="text-gray-600 text-xl hover:text-red-500 transition" />
                                            )}
                                        </div>
                                    </div>

                                    {/* Product Info */}
                                    <div className="p-4 text-center">
                                        <h3 className="font-bold text-gray-800 text-sm line-clamp-2 leading-tight">
                                            {product.name}
                                        </h3>
                                        <p className="text-gray-500 text-xs mt-1 line-clamp-2">
                                            {product.smalldescription}
                                        </p>
                                        <p className="text-red-600 font-bold text-lg mt-3">
                                            ₹{product.price}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SearchPage;